<template>
	<tr>
		<td><router-link :to="`/courses/${golfCourse.uuid}`">{{ golfCourse.name }}</router-link></td>
		<td>{{ golfCourse.full_address }}</td>

	</tr>
</template>
<script>
/** @format */
import CourseFields from '@/fields/courses';
export default {
	name: 'CourseListItem',
	props: {
		golfCourse: {
			type: Object,
			required: true
		}
	},
	components: {
		'course-tees': () => import(/* webpackChunkName: "CourseTees" */ './Tees')
	},
	methods: {
		edit(payload) {
			this.$store.dispatch('notification/add', {type: 'info', message: 'Saving tee data.'});
			this.$store
				.dispatch('courses/edit', { golfCourse: this.golfCourse, payload })
				.then((response) => {
					this.$refs.courseEditForm.resetFieldValues();
					this.$refs.createCourseModal.closeModal();
					this.$emit('course-updated', response.data.data)
					this.$store.dispatch('notification/add', {type: 'success', message: 'Course updated successfully.'});
				})
				.finally(() => {
					this.$refs.courseEditForm.cancelSubmit();
				});
		},
		addTee(payload) {
			this.$store.dispatch('notification/add', {type: 'info', message: 'Saving tee data.'});
			this.$store
				.dispatch('courses/addTee', { golfCourse: this.golfCourse, payload })
				.then((response) => {
					this.$refs.teeForm.resetFieldValues();
					this.$refs.createCourseTeeModal.closeModal();
					this.$store.dispatch('notification/add', {type: 'success', message: 'Course tee added successfully.'});
					this.golfCourse.tees = response.data.data.tees;
				})
				.finally(() => {
					this.$refs.teeForm.submitting = false;
				});
		}
	},
	data() {
		return {
			courseForm: JSON.parse(JSON.stringify(CourseFields)),
			teeForm: [
				{
					name: 'tee',
					label: 'Tee',
					component: 'base-input'
				},
				{
					name: 'hex',
					label: 'Colour (Hex Code) if applicable',
					component: 'base-input'
				},
			]
		}
	}
};
</script>
